module.exports = __webpack_public_path__ + "img/dialog-carSecondLicense.0a03188d.png";